module.exports = __webpack_public_path__ + "static/endo-corporate-logo-cef7cfd91e9af25389d49b949e8fcbac.png";